import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Sentí que por fin alguien estaba poniendo en palabras exactamente lo que yo vivía',
    desc: 'Antes no sabía cómo explicar lo que sentía. Solo sabía que algo estaba mal. Esta guía me ayudó a entender que no estaba loca, ni exagerando. Me devolvió claridad y mucha paz.',
    author: 'Carolina M. — Miami, FL',
    img: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'No me empujó a romper. Me ayudó a mirar mi realidad con honestidad',
    desc: 'Eso fue lo que más valoré. No sentí presión. Sentí comprensión. Y eso me permitió tomar decisiones desde un lugar mucho más consciente.',
    author: 'Ana R. — Houston, TX',
    img: 'https://images.unsplash.com/photo-1611432579699-484f7990b127?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Dejé de sentirme sola dentro de mi propio dolor',
    desc: 'Leer esta guía fue como respirar después de mucho tiempo. Me sentí vista, entendida y acompañada de una forma muy profunda.',
    author: 'Valentina S. — Los Angeles, CA',
    img: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Me ayudó a dejar de vivir como espectadora',
    desc: 'Yo estaba sobreviviendo mi relación sin darme cuenta. Esta guía me ayudó a volver a mí y a dejar de negar lo que sentía.',
    author: 'Lucía P. — New York, NY',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  }];
  return <section className="py-8 md:py-12 px-6 bg-[#F5EBF0]" data-id="element-311">
      <div className="max-w-5xl mx-auto" data-id="element-312">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-313">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-314">TESTIMONIOS</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-315">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream p-6 md:p-8 rounded-2xl shadow-sm border border-softGold/20 flex flex-col h-full" data-id="element-316">
              <div className="flex items-center gap-4 mb-4" data-id="element-317">
                <img src={testimonial.img} alt={testimonial.author} className="w-16 h-16 rounded-full object-cover border-2 border-softGold/30" data-id="element-318" />
                <div className="flex flex-col" data-id="element-319">
                  <div className="flex gap-1 mb-1" data-id="element-320">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-321" />)}
                  </div>
                  <p className="text-sm font-bold text-warmBrown/80 uppercase tracking-wider" data-id="element-322">
                    {testimonial.author}
                  </p>
                </div>
              </div>

              <h3 className="text-xl font-heading font-bold text-terracotta italic mb-3" data-id="element-323">
                “{testimonial.quote}”
              </h3>
              <p className="text-mutedBrown leading-relaxed flex-grow" data-id="element-324">
                {testimonial.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}